import { Component, Prop } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'

import { API } from '@src/lib/api_path'
import { Measurements } from '@src/routes/members/measurements'
import Checkup from '@src/data/checkup'
import { BodyMeasurements } from '@src/data/body-measurement'
import { snakecaseKeys } from '@src/util/functions'

type BodyMeasurementsResponse = { profile: BodyMeasurements }

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    member () {
      return this.$store.state.selectedMember
    }
  }
})
export class WizardMeasurements extends Measurements {

  @Prop({ required: false, default: false })
  protected isReadonly: boolean

  protected checkup: Checkup

  constructor () {
    super()
  }

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  beforeDestroy () {
    if (!this.isReadonly) {
      return this.updateCheckup()
    }
  }

  protected loadBodyMeasurements () {
    return this.apiClient.get<BodyMeasurementsResponse>(API.TRAINERS_API.BODY_MEASUREMENTS.replace('{memberId}', `${this.member.id}`))
      .then((response) => {
        let bodyMeasurements = new BodyMeasurements(camelcaseKeys(response.profile, { deep: true }))

        if (this.isReadonly) {
          // filter the measurements added to the checkup
          Object.keys(bodyMeasurements.metrics).forEach(type => {
            bodyMeasurements.metrics[type] = bodyMeasurements.metrics[type].filter(measurement => {
              return this.checkup.bodyMeasurementIds.includes(measurement.id)
            })
          })
        }

        this.bodyMeasurements = bodyMeasurements
      })
      .catch((error) => console.error('failed to retrieve body measurements', error))
      .finally(() => this.loading = false)
  }

  protected updateCheckup () {
    let checkup = new Checkup(this.checkup)
    let bodyMeasurementIds: number[] = []
    if (this.bodyMeasurements) {
      Object.keys(this.bodyMeasurements.metrics).forEach(type => {
        this.bodyMeasurements!.metrics[type].forEach(measurement => {
          bodyMeasurementIds.push(measurement.id)
        })
      })
    }
    checkup.bodyMeasurementIds = bodyMeasurementIds
    checkup.bodyMeasurementsAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)

    return this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.member.id.toString())}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
      .catch(err => console.error('Failed to update checkup, ', err))
  }
}
